<div class="modal-backdrop" (click)="onClose()">
  <div
    class="modal-container"
    role="dialog"
    aria-modal="true"
    aria-label="Open a workflow"
    (click)="$event.stopPropagation()"
    (keydown.escape)="onClose()"
  >
    <div class="drawer-resizer" appDrawerResize="workflow-selector-drawer-width"></div>

    <div class="selector-header">
      <input
        type="search"
        class="selector-search"
        placeholder="Search workflows…"
        aria-label="Search workflows"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
      />
      <span class="selector-count">
        {{ filtered().length }} of {{ workflows().length }}
        {{ workflows().length === 1 ? 'workflow' : 'workflows' }}
      </span>
      <button type="button" class="selector-close" aria-label="Close" title="Close" (click)="onClose()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="selector-body">
      <div class="workflow-list-pane">
        @if (loading()) {
          <p class="pane-state">Loading workflows…</p>
        } @else if (error()) {
          <div class="pane-state">
            <p>{{ error() }}</p>
            <button type="button" class="link" (click)="reload.emit()">Retry</button>
          </div>
        } @else if (filtered().length === 0) {
          <p class="pane-state">
            @if (query().trim()) {
              No workflows match “{{ query() }}”.
            } @else {
              No workflows saved yet.
            }
          </p>
        } @else {
          <ul class="workflow-items">
            @for (workflow of filtered(); track workflow.id) {
              <li>
                <!-- A div, not a button: it holds the copy button, and a button can't nest one. -->
                <div
                  class="workflow-item"
                  role="button"
                  tabindex="0"
                  [class.selected]="selectedId() === workflow.id"
                  [attr.aria-current]="selectedId() === workflow.id"
                  (click)="onSelect(workflow)"
                  (keydown)="onRowKeydown($event, workflow)"
                >
                  <div class="workflow-item-content">
                    <div class="workflow-item-header">
                      <h3 class="workflow-item-title">{{ workflow.name || 'Untitled' }}</h3>
                      @if (workflow.id === currentWorkflowId()) {
                        <span class="workflow-item-open">Open</span>
                      }
                    </div>

                    <div class="workflow-item-details">
                      <div class="workflow-item-row">
                        <span class="workflow-item-label">ID:</span>
                        <span class="workflow-item-value workflow-item-id">{{ workflow.id }}</span>
                        <app-copy-button [value]="workflow.id" label="ID" />
                      </div>
                      @if (workflow.description) {
                        <div class="workflow-item-row">
                          <span class="workflow-item-label">Description:</span>
                          <span class="workflow-item-value workflow-item-description">{{ workflow.description }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
        }
      </div>

      <section class="preview-pane" aria-label="Workflow nodes" aria-live="polite">
        @if (!selected()) {
          <div class="pane-state">
            <span class="material-symbols-outlined pane-state-icon">account_tree</span>
            <p>Select a workflow to see its nodes here.</p>
          </div>
        } @else if (previewLoading()) {
          <p class="pane-state">Loading nodes…</p>
        } @else if (previewError()) {
          <div class="pane-state">
            <span class="material-symbols-outlined pane-state-icon">error</span>
            <p>{{ previewError() }}</p>
            <button type="button" class="link" (click)="onRetryPreview()">Try again</button>
          </div>
        } @else {
          <header class="preview-header">
            <h3 class="preview-title">{{ selected()?.name || 'Untitled' }}</h3>
            @if (selected()?.description; as description) {
              <p class="preview-description">{{ description }}</p>
            }
            <span class="preview-pill">
              {{ previewRows().length }} {{ previewRows().length === 1 ? 'node' : 'nodes' }}
            </span>
          </header>

          @if (previewRows().length === 0) {
            <p class="pane-state">This workflow has no nodes yet.</p>
          } @else {
            <ol class="preview-nodes">
              @for (row of previewRows(); track row.id) {
                <li class="preview-node" [class]="'node-' + row.type">
                  <div class="preview-node-head">
                    <span class="preview-node-type">{{ row.typeLabel }}</span>
                    <span class="preview-node-name">{{ row.name }}</span>
                  </div>
                  @if (row.endsHere) {
                    <span class="preview-node-next">Ends here</span>
                  } @else if (row.successors.length === 0) {
                    <span class="preview-node-next unconnected">Not connected</span>
                  } @else {
                    @for (next of row.successors; track next.name) {
                      <span class="preview-node-next">
                        @if (next.branch) {
                          <span class="preview-node-branch">{{ next.branch }}</span>
                        }
                        → {{ next.name }}
                      </span>
                    }
                  }
                </li>
              }
            </ol>
          }
        }
      </section>
    </div>

    <div class="selector-footer">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!selected() || selected()?.id === currentWorkflowId()"
        [title]="selected()?.id === currentWorkflowId() ? 'This workflow is already open' : ''"
        (click)="onOpen()"
      >
        Open workflow
      </button>
    </div>
  </div>
</div>
